module.exports = __webpack_public_path__ + "static/media/tag@3x-ticket-nick.2a7d35e0.png";